import type { MediaDto } from '@shelflix/trpc/routes/media/list/useCase';
import Icon from '@shelflix/ui-web/components/Icon';
import { Button } from '@shelflix/ui-web/components/ui/button';
import { Card, CardContent } from '@shelflix/ui-web/components/ui/card';
import { MediaCardVertical } from '../MediaCardVertical';

interface SelectMediaCardProps {
  media: MediaDto;
  onRemove: (media: MediaDto) => void;
  onMoveLeft: () => void;
  onMoveRight: () => void;
  disabledLeft?: boolean;
  disabledRight?: boolean;
}

export function SortableMediaCard({
  media,
  onRemove,
  onMoveLeft,
  onMoveRight,
  disabledLeft,
  disabledRight,
}: SelectMediaCardProps) {
  return (
    <Card className="bg-background relative gap-0 overflow-hidden rounded-[10px] py-0">
      <div className="absolute top-0 right-0 z-20 flex w-full items-end justify-end">
        <Button type="button" variant="ghost" className="p-0">
          <Icon name="close" onClick={() => onRemove(media)} className="text-[#DC3545]" />
        </Button>
      </div>
      <MediaCardVertical media={media} brandName={'teste'} onInfo={() => {}} />
      <CardContent className="flex flex-row justify-between px-0">
        <Button type="button" variant="ghost" onClick={() => onMoveLeft()} disabled={disabledLeft}>
          <Icon name="arrow_left_alt" className="text-primary" size={35} />
        </Button>
        <Button type="button" variant="ghost" onClick={() => onMoveRight()} disabled={disabledRight}>
          <Icon name="arrow_right_alt" className="text-primary" size={35} />
        </Button>
      </CardContent>
    </Card>
  );
}
